import { gql } from "apollo-boost";

/* 
 *  extend type Query {
 *    getClessroom
 *      : [Classroom]
 *  }
 */

export const GET_CLASSROOMS = gql`
  query getClassRooms {
    getClassRooms {
      id
      classRoomOwned {
        id
      }
      degree {
        id
      }
      subjectGroup {
        id
      }
      courseOutlineRegistration {
        id
      }
      classSection {
        id
      }
      sectionNo
      teacher {
        id  
      }
      teacherCode
      subject {
        id
      }
      subjectCode
      nameLocal
      nameEng
      studentRegisterQty
      capacity
      startDate
      endDate
      isAvailable
      isActive
      # classRoomType {
      #   id
      # }
    }
  }
`;
